import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class MainContentService {
	public classes: string[] = [];
}
